module.exports = __webpack_public_path__ + "img/dummyprod1@2x.b2d925a4.png";